"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ChatDisabed = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M7.87559815,3.16982901 L7.92874646,3.24275212 L8.983,4.99992444 L18,5 C19.1045695,5 20,5.8954305 20,7 L20,15 C20,16.1045695 19.1045695,17 18,17 L16.183,16.9999244 L16.9287465,18.2427521 C17.0708205,18.4795423 16.994038,18.7866724 16.7572479,18.9287465 C16.5467678,19.0550345 16.2807104,19.0083989 16.1244018,18.830171 L16.0712535,18.7572479 L15.017,16.9999244 L12,17 L8.62469505,19.700244 C8.19343311,20.0452535 7.56414074,19.9753321 7.21913119,19.5440702 C7.07728075,19.3667572 7,19.1464466 7,18.9193752 L7,17 L6,17 C4.8954305,17 4,16.1045695 4,15 L4,7 C4,5.8954305 4.8954305,5 6,5 L7.817,4.99992444 L7.07125354,3.75724788 C6.92917946,3.52045774 7.00596199,3.21332762 7.24275212,3.07125354 C7.45323224,2.94496547 7.71928964,2.99160114 7.87559815,3.16982901 Z M8.417,5.99992444 L6,5.99992444 C5.48716416,5.99992444 5.06449284,6.38604019 5.00672773,6.88337887 L5,7 L5,15 C5,15.5128358 5.38604019,15.9355072 5.88337887,15.9932723 L6,16 L8,16 L8,18.9193752 L11.6492189,16 L14.417,15.9999244 L8.417,5.99992444 Z M18,5.99992444 L9.583,5.99992444 L15.583,16 L18,16 C18.5128358,16 18.9355072,15.6139598 18.9932723,15.1166211 L19,15 L19,7 C19,6.48716416 18.6139598,6.06449284 18.1166211,6.00672773 L18,5.99992444 Z" })));
};
ChatDisabed.displayName = 'ChatDisabed';
exports.default = ChatDisabed;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChatDisabed.js.map